import { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { electronicInvoicingApi } from "../../api/electronicInvoicingApi";

export default function InvoiceSyncLogsPage() {
  const { token } = useAuth() as any;
  const [logs, setLogs] = useState<any[]>([]);

  useEffect(() => {
    electronicInvoicingApi.getSyncLogs(token).then(setLogs).catch(() => setLogs([]));
  }, [token]);

  return (
    <div className="container-fluid">
      <h3 className="mb-3">Log sincronizzazione</h3>
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table mb-0">
            <thead className="table-light">
              <tr>
                <th>Data/Ora</th>
                <th>Livello</th>
                <th>Messaggio</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l, i) => (
                <tr key={`${l.at}-${i}`}>
                  <td>{new Date(l.at).toLocaleString("it-IT")}</td>
                  <td><span className="badge text-bg-secondary">{l.level}</span></td>
                  <td>{l.message}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr><td colSpan={3} className="text-center text-muted py-4">Nessun log disponibile</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
